import { StyledLeaf, createPluginFactory, isText, withProps, } from '@udecode/plate';
import { Editor, Range, } from 'slate';
export const LAST_SELECTION_MARK = 'LastSelectionMark';
export const decorateLastSelection = (editor, 
// eslint-disable-next-line @typescript-eslint/no-unused-vars
{ key, type }) => ([node, path]) => {
    const editorWithLastSelection = editor;
    if (editor.selection) {
        editorWithLastSelection.lastActiveSelection = editor.selection;
    }
    const { lastActiveSelection } = editorWithLastSelection;
    if (isText(node)
        // && editor.selection == null
        && lastActiveSelection !== undefined) {
        if (lastActiveSelection === undefined) {
            return [];
        }
        const intersection = Range.intersection(lastActiveSelection, Editor.range(editor, path));
        if (intersection == null) {
            return [];
        }
        const range = {
            [type]: true,
            ...intersection,
        };
        // console.log('Returning range:', range);
        return [range];
    }
    return [];
};
export const createLastSelectionPlugin = createPluginFactory({
    key: LAST_SELECTION_MARK,
    isLeaf: true,
    decorate: decorateLastSelection,
    // @ts-expect-error - TODO: fix this
    component: withProps(StyledLeaf, {
        as: 'span',
        styles: {
            root: {
                background: '#D9D9D9',
            },
        },
    }),
});
//# sourceMappingURL=lastSelectionPlugin.js.map